module.exports = "/_next/static/images/desktop_microsalts_banner-49fe91835a3253bef2309496d1f737b8.png";